module.exports = __webpack_public_path__ + "static/img/guanjun_1.37767bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/guanjun_1.png
// module id = Q55o
// module chunks = 1